<template>
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="3" class="mb-md-0 mb-1">
          <label>Дата начала</label>
          <flat-pickr v-model="from" class="form-control" :config="datePickerConfig" placeholder="Не задано" />
        </b-col>
        <b-col cols="12" md="3" class="mb-md-0 mb-1">
          <label>Дата конца</label>
          <flat-pickr v-model="to" class="form-control" :config="datePickerConfig" placeholder="Не задано" />
        </b-col>
        <b-col cols="12" md="3" class="d-flex align-items-end mb-md-0 mb-1">
          <b-form-checkbox v-model="onlyActive">Только активные</b-form-checkbox>
        </b-col>
        <b-col cols="12" md="3" class="d-flex justify-content-end align-items-end">
          <b-button variant="outline-secondary" class="mr-1" @click="reset">Сбросить</b-button>
          <b-button variant="primary" @click="apply">Применить</b-button>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col>
          <b-button-group size="sm">
            <b-button variant="outline-secondary" @click="setPreset('thisMonth')">Текущий месяц</b-button>
            <b-button variant="outline-secondary" @click="setPreset('lastMonth')">Прошлый месяц</b-button>
            <b-button variant="outline-secondary" @click="setPreset('quarter')">Квартал</b-button>
            <b-button variant="outline-secondary" @click="setPreset('year')">Год</b-button>
          </b-button-group>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BButton, BButtonGroup, BFormCheckbox,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { ref } from '@vue/composition-api'
import { presetRange } from '@/views/finance/utils'

export default {
  components: {
    BCard, BCardBody, BRow, BCol, BButton, BButtonGroup, BFormCheckbox, flatPickr,
  },
  setup(_, { emit }) {
    const from = ref('')
    const to = ref('')
    const onlyActive = ref(false)
    const datePickerConfig = { dateFormat: 'Y-m-d', altInput: true, altFormat: 'd.m.Y' }

    const buildPayload = () => ({
      from: from.value,
      to: to.value,
      onlyActive: onlyActive.value,
    })

    const apply = () => emit('apply', buildPayload())

    const reset = () => {
      from.value = ''
      to.value = ''
      onlyActive.value = false
      emit('apply', buildPayload())
    }

    const setPreset = name => {
      const range = presetRange(name)
      from.value = range.from
      to.value = range.to
      emit('apply', buildPayload())
    }

    return { from, to, onlyActive, datePickerConfig, apply, reset, setPreset }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
